import { Table } from "antd";
import React, { useEffect, useState } from "react";

export const RefreshTable = ({ expClusterInfo, vmDumpSummary}) => {
  const [nodesData, setNodesData] = useState({});
  

  useEffect(() => {
    if (expClusterInfo?.nodes) {
      let filteredData = expClusterInfo?.nodes?.find(
        (node) => node?.Node === "usage_stats_percentage"
      );
      setNodesData(filteredData ? filteredData?.[0] : {});
    }
  }, [expClusterInfo]);

  const data = [
    {
      key: "1",
      metric: "CPU",
      min: Math.round((nodesData?.MIN_CPU || 0) * 100) / 100, // Rounded to 2 decimals
      max: Math.round((nodesData?.MAX_CPU || 0) * 100) / 100,
      mean: Math.round((nodesData?.AVG_CPU_FROM_MV_CLUSTER || 0) * 100) / 100,
      slope_per_day: nodesData?.CPU_SLOPE || 0,
    },
    {
      key: "2",
      metric: "MEM",
      min: Math.round((nodesData?.MIN_MEM || 0) * 100) / 100, // Rounded to 2 decimals
      max: Math.round((nodesData?.MAX_MEM || 0) * 100) / 100,
      mean: Math.round((nodesData?.AVG_MEM_FROM_MV_CLUSTER || 0) * 100) / 100,
      slope_per_day: nodesData?.MEM_SLOPE || 0,
    },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "metric",
      key: "metric",
    },
    {
      title: "Min",
      dataIndex: "min",
      key: "min",
    },
    {
      title: "Max",
      dataIndex: "max",
      key: "max",
    },
    {
      title: "Mean",
      dataIndex: "mean",
      key: "mean",
    },
    {
      title: "Slope per day",
      dataIndex: "slope_per_day",
      key: "slope_per_day",
    },
  ];

  const vmDumpSummaryColumns = [
    {
      title: "CPUs Total",
      dataIndex: "cpus_total",
      key: "cpus_total",
    },
    {
      title: "Memory Total (MB)",
      dataIndex: "memory_total",
      key: "memory_total",
    },
    {
      title: "Disk Capacity Total (GB)",
      dataIndex: "disk_capacity_total_gb",
      key: "disk_capacity_total_gb",
    },
  ];

  const vmDumpSummaryData = [
    {
      key: "1",
      cpus_total: vmDumpSummary?.cpus_total || 0,
      memory_total: vmDumpSummary?.memory_total || 0,
      disk_capacity_total_gb: vmDumpSummary?.disk_capacity_total_gb || 0,
    },
  ];

  const Warranty_columns = [
    {
      title: "Host",
      dataIndex: "HOST",
      key: "HOST",
    },
    {
      title: "Server Install Date",
      dataIndex: "SERVER_INSTALL_DATE",
      key: "SERVER_INSTALL_DATE",
    },
    {
      title: "Warranty Expiry Date",
      dataIndex: "SERVER_WARRTY_EXPIR_DATE",
      key: "SERVER_WARRTY_EXPIR_DATE",
    },
  ];

  return (
    <div>
      <div>
        <h4>Usage stats %: </h4>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          size="small"
          style={{ marginBottom: "20px" }}
        />
      </div>
      {vmDumpSummary && (<div>
        <h4>VM Dump Summary: </h4>
        <Table
          columns={vmDumpSummaryColumns}
          dataSource={vmDumpSummaryData}
          pagination={false}
          bordered
          size="small"
          style={{ marginBottom: "20px" }}
        />
      </div>)}
     
      <div>
        {expClusterInfo?.warranty_details?.length !== 0 ? (
          <>
            <h4>Warranty Details: </h4>
            <Table
              columns={Warranty_columns}
              dataSource={expClusterInfo?.warranty_details}
              pagination={false}
              bordered
              size="small"
              style={{ marginBottom: "20px" }}
            />
          </>
        ) : (
           <div>
          <h4>Note: No warranty details available. </h4>
           </div>
        )}
      </div>
    </div>
  );
};
